import mixpanel, { type Dict, type OverridedMixpanel } from 'mixpanel-browser'

import { SG_AGNOSTIC_USER_KEY, TOKEN_STORAGE_KEY } from 'auth/domain/User'

import { __DEV__ } from '../../infra/environment'
import { LocalStorageClient } from '../../infra/storage/LocalStorageClient'

type MixpanelWithShipperGuideProperty = {
  shipper_guide?: OverridedMixpanel
} & typeof mixpanel

const mixpanelWithShipperGuideProperty = mixpanel as MixpanelWithShipperGuideProperty

/** @deprecated Use {@link getAnalyticsUserForMixpanel} from `core/analytics/getAnalyticsUser`. */
function getAgnosticUserForAnalytics() {
  const storage = new LocalStorageClient()
  const user = storage.get(SG_AGNOSTIC_USER_KEY)
  const isLoggedIn = storage.get(TOKEN_STORAGE_KEY) ? true : false

  if (user) {
    return {
      ...user,
      id: user.email,
      name: user.email,
      isLoggedIn,
    }
  }
  return null
}

/**
 * @deprecated Use `analytics` from `core/analytics/analytics` instead.
 * Legacy ShipperGuide mixpanel client (logged-in session only; no magic-link token).
 */
export const analytics = {
  init() {
    if (mixpanelWithShipperGuideProperty.shipper_guide) return false

    if (!this.isMixpanelEnabled()) return false

    mixpanelWithShipperGuideProperty.init(
      process.env.REACT_APP_SHIPPER_GUIDE_MIXPANEL_TOKEN!,
      {},
      'shipper_guide'
    )
  },

  track(label: string, obj?: Dict) {
    if (!this.isMixpanelEnabled()) return false

    if (mixpanelWithShipperGuideProperty.shipper_guide) {
      mixpanelWithShipperGuideProperty.shipper_guide.track(label, obj)

      if (__DEV__) console.info('SHIPPER GUIDE MIXPANEL EVENT:', label, obj || '')
    }
  },

  setup() {
    const shipperGuideUser = getAgnosticUserForAnalytics()
    if (mixpanelWithShipperGuideProperty.shipper_guide && shipperGuideUser) {
      const { id, email, name, company, type, roles, shipper_test, user_category, business_type } =
        shipperGuideUser
      mixpanelWithShipperGuideProperty.shipper_guide.register(shipperGuideUser)
      mixpanelWithShipperGuideProperty.shipper_guide.identify(shipperGuideUser.email)
      mixpanelWithShipperGuideProperty.shipper_guide.people.set({
        id,
        $email: email,
        $name: name,
        company,
        roles,
        type,
        shipper_test,
        user_category,
        business_type,
      })
    }
  },

  isMixpanelEnabled() {
    return typeof mixpanel !== 'undefined'
  },
}
